import Button, {
  ButtonTypes,
} from "../../../../common/components/button/button";
import TextField from "../../../../common/components/inputFields/textFields/textField";
import PopupLayout from "../../../../common/components/layouts/popupLayout/popupLayout";
import "./addPolicyPopup.scss";

export default function AddPolicyPopup(props: {
  initialValue?: string;
  onConfirm?: (e: string) => void;
  onCancel?: () => void;
}) {
  let text = "";
  return (
    <PopupLayout ttle="Add Policy" onClickClose={props.onCancel}>
      <div className="add-policy-content">
        <TextField
          initialValue={props.initialValue}
          title="policy detail"
          extendable
          height="150px"
          placeHolder="writing plain text or html"
          onChange={(e) => (text = e)}
        />
        <div className="add-policy-buttons-container">
          <Button
            type={ButtonTypes.OUTLINED}
            text={"Cancel"}
            onClick={props.onCancel}
          />
          <Button
            type={ButtonTypes.PRIMARY}
            text={"Confirm"}
            onClick={() => props.onConfirm?.(text)}
          />
        </div>
      </div>
    </PopupLayout>
  );
}
